import React from "react";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import { Visibility } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import LinearProgress from '@mui/material/LinearProgress';
import {
	SIZES,
	SORT_ORDERS,
	ALIGN,
	HTML_TAGS,
} from "../../common/constants/commonConstants.js";
import { DATA_REVIEW_COLUMN_KEYS, DATA_REVIEW_CONSTANTS } from "../../common/constants/dataModule/dataReviewConstants.js";
const DataReviewTable = ({
	page,
	order,
	setPage,
	orderBy,
	rowsPerPage,
	isLoading,
	dataReviewToDisplay,
	setRowsPerPage,
	columns,
	onReview,
	handleRequestSort,
	filteredUploadDateListLength,
}) => {
	return (
		<>
			<TableContainer sx={{ mt: 2 }}>
				<Table size={SIZES.SMALL}>
					<TableHead>
						<TableRow>
							{columns.map((column) => (
								<TableCell
									key={column.id}
									sortDirection={orderBy === column.id ? order : false}
									align={
										column.id === DATA_REVIEW_COLUMN_KEYS.ACTIONS
											? ALIGN.CENTER
											: ALIGN.LEFT
									}
									sx={{
										width:
											column.id === DATA_REVIEW_COLUMN_KEYS.ACTIONS ? 50 :
												column.id === DATA_REVIEW_COLUMN_KEYS.CAMPAIGN_NAME ? 200 :
													column.id === DATA_REVIEW_COLUMN_KEYS.UPLOAD_DATE ? 200 : 150,
									}}
								>
									{column.isSortable ? (
										<TableSortLabel
											active={orderBy === column.id}
											direction={orderBy === column.id ? order : SORT_ORDERS.ASCENDING}
											onClick={() =>
												handleRequestSort(column.id)
											}
										>
											{column.label}
										</TableSortLabel>
									) : column.label}
								</TableCell>
							))}
						</TableRow>
					</TableHead>

					<TableBody>
						{isLoading ? (
							<TableRow>
								<TableCell colSpan={columns.length} align={ALIGN.CENTER}>
									<LinearProgress />
								</TableCell>
							</TableRow>
						) : dataReviewToDisplay?.length > 0 ? (
							dataReviewToDisplay.map((dataReview) => (
								<TableRow hover tabIndex={-1} key={dataReview.id}>
									<TableCell align={ALIGN.CENTER}>
										<IconButton onClick={() => onReview(dataReview)}>
											<Visibility fontSize={SIZES.SMALL} />
										</IconButton>
									</TableCell>
									<TableCell>
										{dataReview.campaignName}
									</TableCell>
									<TableCell>
										{dataReview.uploaddate}
									</TableCell>
								</TableRow>
							))
						) : (
							<TableRow>
								<TableCell colSpan={columns?.length} align={ALIGN.CENTER}>
									{DATA_REVIEW_CONSTANTS.NO_DATA}
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
				<TablePagination
					page={page}
					rowsPerPage={rowsPerPage}
					component={HTML_TAGS.DIV}
					count={filteredUploadDateListLength}
					rowsPerPageOptions={[10, 25, 50]}
					onPageChange={(event, newPage) => setPage(newPage)}
					onRowsPerPageChange={(event) => {
						setPage(0);
						setRowsPerPage(parseInt(event.target.value, 10));
					}}
				/>
			</TableContainer>
		</>
	);
};

export default DataReviewTable;